import React, { useEffect, useState } from "react";
import { Form, Input, Select } from "antd";
const InputCode = (props) => {
  const { name, value, onChange, onPressEnter, ...rest } = props;

  const [formatValue, setFormatValue] = useState<string>(
    value?.toString().toUpperCase()
  );
  const onChangeInternal = (e) => {
    onChange(e);
    setFormatValue(e.target.value?.toString().toUpperCase() || "");
  };
  useEffect(() => {}, [formatValue]);
  return (
    <Input
      prefix={null}
      suffix={null}
      className="input-code"
      value={formatValue}
      onChange={(e) => onChangeInternal(e)}
      onPressEnter={onPressEnter}
      // {...rest}
    ></Input>
  );
};
export default InputCode;
